<ng-template #mediaContent let-item="item" let-size="size">
  @if (item.video; as video) {
    <div [style.height.px]="size.dh" class="video-wrapper">
      <app-video
        [autoplay]="true"
        [cover]="true"
        [isLoop]="video.isLoop ?? true"
        [isMuted]="video.isMuted ?? true"
        [mp4Url]="video.mp4Url"
        [previewImage]="video.image" />
    </div>
  } @else if (item.image) {
    <app-image [image]="item.image" [size]="size" class="img" />
  }
  @if (item.legend; as legend) {
    <figcaption>
      <hr class="separator" />
      <div [innerHTML]="legend" class="legend"></div>
    </figcaption>
  }
</ng-template>

<section class="gallery-layout gallery-layout-9">
  <div class="container">
    <div class="row">
      @if (data().items[0]; as item) {
        <div class="col-lg-5 col-xs-12">
          <figure class="figure figure-0">
            <ng-container
              *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 500, dh: 626, mh: 421 } }" />
          </figure>
        </div>
      }
      @if (data().items[1]; as item) {
        <div class="col-lg-6 col-lg-offset-1 col-xs-12">
          <figure class="figure figure-1">
            <ng-container
              *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 600, dh: 758, mh: 421 } }" />
          </figure>
        </div>
      }
    </div>
    <div class="row">
      @if (data().items[2]; as item) {
        <div class="col-lg-4 col-lg-offset-1 col-xs-12">
          <figure class="figure figure-2">
            <ng-container
              *ngTemplateOutlet="mediaContent; context: { item: item, size: { dw: 400, dh: 504, mh: 421 } }" />
          </figure>
        </div>
      }
      @if (data().quote) {
        <div class="col-lg-6 col-lg-offset-1 col-xs-12">
          <app-quote [quote]="{ text: data().quote! }" class="quote" theme="BROWN" />
        </div>
      }
    </div>
  </div>
</section>
